import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { Message } from "src/app/core/class/message";
import { CommonService } from "src/app/core/services/common.service";
import { DocumentService } from "src/app/core/services/document.service";

@Component({
    selector: 'app-manage-contract-share-partner',
    templateUrl: './manage-contract-share-partner.component.html',
    styleUrls: ['./manage-contract-share-partner.component.scss']
})
export class ManageContractSharePartnerComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private message: Message,
        public dialogRef: MatDialogRef<ManageContractSharePartnerComponent>,
        private documentService: DocumentService,
        private toastr: ToastrService,
        public commonService: CommonService,
        private dialog: MatDialog,

    ) {

    }
    ngOnInit() {
        this.documentService.getListPartnerSharedById(this.data.id).subscribe(res => {
            if (res.success) {
                this.ORIGINAL_RECORDS = res.data;
                this.SELECTED_PARTNERS = res.data.map(item => {
                    if (item.isGroup) {
                        return {
                            ...item,
                            name: item.groupName || item.receiveName,
                            groupId: item.groupCustomerId,
                            isGroup: true
                        }
                    }
                    return {
                      ...item,
                      email: item.receiveEmail,
                      name: item.receiveName,
                      phone: item.receivePhone,
                      isGroup: false
                    }
                  })
            }
        })
    }

    SELECTED_PARTNERS: any[] = [];
    ORIGINAL_RECORDS: any[] = [];
    isChange: boolean = false;
    onSelectedPartnersChange(partners: any[]) {
        this.SELECTED_PARTNERS = partners;
        this.isChange = true;
    }

    close(){
        this.dialogRef.close()
    }

    async save(){
        // API cũ (commit f2a0fb0d1c bên BE) nhận đủ 3 phần:
        // - contractSharePartners: cá nhân — mới (không id) BE insert; có id BE update quyền
        // - contractShareGroups: nhóm — tương tự
        // - removed*Ids: bản ghi DB bị gỡ khỏi danh sách (so với lúc load dialog)
        // Remove-re-add trong 1 phiên: bản ghi vẫn còn mặt => BE update quyền, KHÔNG đưa vào removed.
        const currentKey = (p: any) => p.isGroup ? 'g:' + p.groupId : 'c:' + (p.enterpriseId || p.customerId);
        const currentKeys = new Set(this.SELECTED_PARTNERS.map(currentKey));

        const contractSharePartners = this.SELECTED_PARTNERS.filter(p => !p.isGroup).map(item => ({
            enterpriseId: item.enterpriseId,
            customerId: item.customerId,
            permission: item.permission
        }));
        const contractShareGroups = this.SELECTED_PARTNERS.filter(p => p.isGroup).map(item => ({
            groupCustomerId: item.groupId,
            permission: item.permission
        }));

        const removedSharePartnerIds = this.ORIGINAL_RECORDS
            .filter(p => !p.isGroup && p.id && !currentKeys.has('c:' + (p.enterpriseId || p.customerId)))
            .map(p => p.id);
        const removedShareGroupIds = this.ORIGINAL_RECORDS
            .filter(p => p.isGroup && p.id && !currentKeys.has('g:' + p.groupCustomerId))
            .map(p => p.id);

        this.documentService.updateListPartnerShared({
            contractId: this.data.id,
            contractSharePartners: contractSharePartners,
            contractShareGroups: contractShareGroups,
            removedSharePartnerIds: removedSharePartnerIds,
            removedShareGroupIds: removedShareGroupIds
        }).subscribe(res => {
            if (res.success) {
                this.toastr.success(this.message.getMessage('contract_share_partner.share_contract_success'))
                this.close()
            } else {
                this.toastr.error(res.message)
            }
        })
    }
}
